<template>
  <div class="audit_temp" :class="resultObj[audit_status].label" v-if="audit_status !== 3">
    <p>审核状态：{{ resultObj[audit_status].name }}</p>
    <p v-if="audit_status === 1">{{ audit_remark }}</p>
  </div>
</template>

<script>
export default {
  name: 'AuditTemp',
  props: {
    audit_status: {
      type: Number,
      default: 0
    },
    audit_remark: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      resultObj: {
        1: { name: '总决赛审查退回', label: 'error' },
        2: { name: '总决赛审查通过，等待总决赛答辩', label: 'info' },
        3: { name: '总决赛作品未提交', label: 'normal' },
        4: { name: '总决赛作品审核中', label: 'warning' },
        5: { name: '总决赛结束，公布获奖结果', label: 'success' }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
